/**
 * @generated SignedSource<<38bdc30c3c6e60f4ae8237abec734928>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CertificateMutationsRemoveMutation$variables = {
  id: string;
};
export type CertificateMutationsRemoveMutation$data = {
  readonly deleteCertificateInfo: {
    readonly id: string;
  };
};
export type CertificateMutationsRemoveMutation = {
  response: CertificateMutationsRemoveMutation$data;
  variables: CertificateMutationsRemoveMutation$variables;
};

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'id',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'id',
          },
        ],
        concreteType: 'CertificateInfo',
        kind: 'LinkedField',
        name: 'deleteCertificateInfo',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'id',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'CertificateMutationsRemoveMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'CertificateMutationsRemoveMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'c20213344574d3a4db30f97bb7a62a49',
      id: null,
      metadata: {},
      name: 'CertificateMutationsRemoveMutation',
      operationKind: 'mutation',
      text: 'mutation CertificateMutationsRemoveMutation(\n  $id: ID!\n) {\n  deleteCertificateInfo(id: $id) {\n    id\n  }\n}\n',
    },
  };
})();

(node as any).hash = '6947e9060494982802a8891158ddc6b6';

export default node;
